import * as React from 'react';
import { styled } from '@linaria/react';

import { Wrapper, Label } from './EquationMask.helpers';

function EquationMaskIntro() {
  return (
    <Wrapper>
      <Column>
        <Label>Element</Label>
        <Img src="/images/backdrop-filter/mask-before.png" />
      </Column>
      <Symbol>+</Symbol>
      <Column>
        <Label>Mask</Label>
        <FakeMask>
          <Squares />
          <Blocker />
        </FakeMask>
      </Column>
      <Symbol>=</Symbol>
      <Column>
        <Label>Result</Label>
        <Img src="/images/backdrop-filter/mask-after.png" />
      </Column>
    </Wrapper>
  );
}

const Column = styled.div`
  position: relative;
  width: 202px;
  min-width: 0;
  aspect-ratio: 404 / 271;
  outline: 1px solid var(--color-gray-300);
`;

const Img = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Symbol = styled.div`
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4rem;
  font-family: var(--font-family-mono);
`;

const FakeMask = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Blocker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: calc(50% - 2px);
  background: black;
`;

const Squares = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.4;
  background-image: url('/images/backdrop-filter/transparent-squares.png');
  background-size: 20px 20px;
  transition: opacity var(--color-swap-duration);

  html[data-color-mode='dark'] & {
    opacity: 0.2;
  }
`;

export default EquationMaskIntro;
